import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Badge, Btn, CustomModal, DateTime, InputText, TextBtn } from '../../../../../components'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { gray, verde, vinho } from '../../../../../assets/js/colors'
import { partnerLabel } from './integrationPartners'

// Tokens de uma integração: gerar (rotação = gerar um novo e revogar o antigo depois que o
// parceiro trocar) e revogar. O token é identificado pelo prefixo (8 caracteres após tpm_),
// que é o que o parceiro informa ao suporte.
export default function CredentialsModal({ integration, onGenerate, onRevoke, onClose }) {
  const [description, setDescription] = useState('')

  useEffect(() => {
    if (integration) setDescription('')
  }, [integration && integration.id])

  if (!integration) return null

  return (
    <CustomModal
      header={`Tokens da integração ${partnerLabel(integration.partner)}`}
      isVisible={!!integration}
      onClose={onClose}
      width="900px"
    >
      <div className="p-grid">
        {!integration.active && (
          <div className="p-col-12" style={{ color: vinho }}>
            Integração inativa: os tokens abaixo são recusados até a integração ser ativada.
          </div>
        )}
        <div className="p-col-9">
          <InputText
            label="Descrição do novo token (ex.: Token entregue à TI do parceiro em 20/10/2026)"
            value={description}
            onChange={setDescription}
          />
        </div>
        <div className="p-col-3" style={{ marginTop: 28 }}>
          <Btn onClick={() => onGenerate(integration, description)}>Gerar token</Btn>
        </div>
        <div className="p-col-12">
          <DataTable value={integration.credentials} emptyMessage="Nenhum token gerado">
            <Column header="Prefixo" field="prefix" style={tableCellCentered(100)} />
            <Column header="Descrição" body={c => c.description || '-'} />
            <Column
              header="Criado em"
              style={tableCellCentered(150)}
              body={c => (
                <>
                  <DateTime>{c.created_at}</DateTime>
                  {c.created_by_name ? <div>{c.created_by_name}</div> : null}
                </>
              )}
            />
            <Column
              header="Último uso"
              style={tableCellCentered(150)}
              body={c => (c.last_used_at ? <DateTime>{c.last_used_at}</DateTime> : '-')}
            />
            <Column
              header="Situação"
              style={tableCellCentered(150)}
              body={c =>
                c.revoked_at ? (
                  <>
                    <Badge color={gray}>Revogado</Badge>
                    <div>
                      <DateTime>{c.revoked_at}</DateTime>
                    </div>
                    {c.revoked_by_name ? <div>{c.revoked_by_name}</div> : null}
                  </>
                ) : (
                  <Badge color={verde}>Ativo</Badge>
                )
              }
            />
            <Column
              header="Ações"
              style={tableCellCentered(90)}
              body={c =>
                c.revoked_at ? null : (
                  <TextBtn onClick={() => onRevoke(integration, c)}>Revogar</TextBtn>
                )
              }
            />
          </DataTable>
        </div>
      </div>
    </CustomModal>
  )
}
